const user = require('./user');
const meal = require('./meal');
const booking = require('./booking');
const review = require('./review');
const talentPoolApplication = require('./talentPoolApplication');

module.exports = {
  ...user,
  ...meal,
  ...booking,
  ...review,
  ...talentPoolApplication,
};
